/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CampaignControllerDtoCampaignDetailCampaignDetailData model module.
 * @module model/CampaignControllerDtoCampaignDetailCampaignDetailData
 * @version 1.0
 */
class CampaignControllerDtoCampaignDetailCampaignDetailData {
    /**
     * Constructs a new <code>CampaignControllerDtoCampaignDetailCampaignDetailData</code>.
     * @alias module:model/CampaignControllerDtoCampaignDetailCampaignDetailData
     */
    constructor() { 
        
        CampaignControllerDtoCampaignDetailCampaignDetailData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CampaignControllerDtoCampaignDetailCampaignDetailData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CampaignControllerDtoCampaignDetailCampaignDetailData} obj Optional instance to populate.
     * @return {module:model/CampaignControllerDtoCampaignDetailCampaignDetailData} The populated <code>CampaignControllerDtoCampaignDetailCampaignDetailData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CampaignControllerDtoCampaignDetailCampaignDetailData();

            if (data.hasOwnProperty('walletAddress')) {
                obj['walletAddress'] = ApiClient.convertToType(data['walletAddress'], 'String');
            }
            if (data.hasOwnProperty('depositAmount')) {
                obj['depositAmount'] = ApiClient.convertToType(data['depositAmount'], 'Number');
            }
            if (data.hasOwnProperty('packageName')) {
                obj['packageName'] = ApiClient.convertToType(data['packageName'], 'String');
            }
            if (data.hasOwnProperty('appTitle')) {
                obj['appTitle'] = ApiClient.convertToType(data['appTitle'], 'String');
            }
            if (data.hasOwnProperty('appProfileImage')) {
                obj['appProfileImage'] = ApiClient.convertToType(data['appProfileImage'], 'String');
            }
            if (data.hasOwnProperty('campaignType')) {
                obj['campaignType'] = ApiClient.convertToType(data['campaignType'], 'Number');
            }
            if (data.hasOwnProperty('campaignTitle')) {
                obj['campaignTitle'] = ApiClient.convertToType(data['campaignTitle'], 'String');
            }
            if (data.hasOwnProperty('startAt')) {
                obj['startAt'] = ApiClient.convertToType(data['startAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
            if (data.hasOwnProperty('appNo')) {
                obj['appNo'] = ApiClient.convertToType(data['appNo'], 'Number');
            }
            if (data.hasOwnProperty('isLock')) {
                obj['isLock'] = ApiClient.convertToType(data['isLock'], 'Boolean');
            }
            if (data.hasOwnProperty('campaignLogoImage')) {
                obj['campaignLogoImage'] = ApiClient.convertToType(data['campaignLogoImage'], 'String');
            }
            if (data.hasOwnProperty('campaignDesc')) {
                obj['campaignDesc'] = ApiClient.convertToType(data['campaignDesc'], 'String');
            }
            if (data.hasOwnProperty('region')) {
                obj['region'] = ApiClient.convertToType(data['region'], 'String');
            }
            if (data.hasOwnProperty('needMinNftGrade')) {
                obj['needMinNftGrade'] = ApiClient.convertToType(data['needMinNftGrade'], 'Number');
            }
            if (data.hasOwnProperty('needMinNftLevel')) {
                obj['needMinNftLevel'] = ApiClient.convertToType(data['needMinNftLevel'], 'Number');
            }
            if (data.hasOwnProperty('needNftType')) {
                obj['needNftType'] = ApiClient.convertToType(data['needNftType'], 'Number');
            }
            if (data.hasOwnProperty('needType')) {
                obj['needType'] = ApiClient.convertToType(data['needType'], 'Number');
            }
            if (data.hasOwnProperty('needValue')) {
                obj['needValue'] = ApiClient.convertToType(data['needValue'], 'Number');
            }
            if (data.hasOwnProperty('initialPerDeposited')) {
                obj['initialPerDeposited'] = ApiClient.convertToType(data['initialPerDeposited'], 'Number');
            }
            if (data.hasOwnProperty('dailyPerLeftover')) {
                obj['dailyPerLeftover'] = ApiClient.convertToType(data['dailyPerLeftover'], 'Number');
            }
            if (data.hasOwnProperty('usePowerDayLimit')) {
                obj['usePowerDayLimit'] = ApiClient.convertToType(data['usePowerDayLimit'], 'Number');
            }
            if (data.hasOwnProperty('perOfBasicPower')) {
                obj['perOfBasicPower'] = ApiClient.convertToType(data['perOfBasicPower'], 'Number');
            }
            if (data.hasOwnProperty('perBasicPower')) {
                obj['perBasicPower'] = ApiClient.convertToType(data['perBasicPower'], 'Number');
            }
            if (data.hasOwnProperty('xperOfBasicPower')) {
                obj['xperOfBasicPower'] = ApiClient.convertToType(data['xperOfBasicPower'], 'Number');
            }
            if (data.hasOwnProperty('xperBasicPower')) {
                obj['xperBasicPower'] = ApiClient.convertToType(data['xperBasicPower'], 'Number');
            }
            if (data.hasOwnProperty('partnerNo')) {
                obj['partnerNo'] = ApiClient.convertToType(data['partnerNo'], 'Number');
            }
            if (data.hasOwnProperty('partnerEmail')) {
                obj['partnerEmail'] = ApiClient.convertToType(data['partnerEmail'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
            }
            if (data.hasOwnProperty('depositTransactionStatus')) {
                obj['depositTransactionStatus'] = ApiClient.convertToType(data['depositTransactionStatus'], 'Number');
            }
            if (data.hasOwnProperty('partnerWalletNo')) {
                obj['partnerWalletNo'] = ApiClient.convertToType(data['partnerWalletNo'], 'Number');
            }
            if (data.hasOwnProperty('x2eZone')) {
                obj['x2eZone'] = ApiClient.convertToType(data['x2eZone'], 'Boolean');
            }
            if (data.hasOwnProperty('isAdvertised')) {
                obj['isAdvertised'] = ApiClient.convertToType(data['isAdvertised'], 'Boolean');
            }
            if (data.hasOwnProperty('isEqualNftGrade')) {
                obj['isEqualNftGrade'] = ApiClient.convertToType(data['isEqualNftGrade'], 'Boolean');
            }
            if (data.hasOwnProperty('enableStartAt')) {
                obj['enableStartAt'] = ApiClient.convertToType(data['enableStartAt'], 'String');
            }
            if (data.hasOwnProperty('enableEndAt')) {
                obj['enableEndAt'] = ApiClient.convertToType(data['enableEndAt'], 'String');
            }
            if (data.hasOwnProperty('plusFlag')) {
                obj['plusFlag'] = ApiClient.convertToType(data['plusFlag'], 'Boolean');
            }
            if (data.hasOwnProperty('ticketId')) {
                obj['ticketId'] = ApiClient.convertToType(data['ticketId'], 'Number');
            }
            if (data.hasOwnProperty('ticketCount')) {
                obj['ticketCount'] = ApiClient.convertToType(data['ticketCount'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CampaignControllerDtoCampaignDetailCampaignDetailData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CampaignControllerDtoCampaignDetailCampaignDetailData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['walletAddress'] && !(typeof data['walletAddress'] === 'string' || data['walletAddress'] instanceof String)) {
            throw new Error("Expected the field `walletAddress` to be a primitive type in the JSON string but got " + data['walletAddress']);
        }
        // ensure the json data is a string
        if (data['packageName'] && !(typeof data['packageName'] === 'string' || data['packageName'] instanceof String)) {
            throw new Error("Expected the field `packageName` to be a primitive type in the JSON string but got " + data['packageName']);
        }
        // ensure the json data is a string
        if (data['appTitle'] && !(typeof data['appTitle'] === 'string' || data['appTitle'] instanceof String)) {
            throw new Error("Expected the field `appTitle` to be a primitive type in the JSON string but got " + data['appTitle']);
        }
        // ensure the json data is a string
        if (data['appProfileImage'] && !(typeof data['appProfileImage'] === 'string' || data['appProfileImage'] instanceof String)) {
            throw new Error("Expected the field `appProfileImage` to be a primitive type in the JSON string but got " + data['appProfileImage']);
        }
        // ensure the json data is a string
        if (data['campaignTitle'] && !(typeof data['campaignTitle'] === 'string' || data['campaignTitle'] instanceof String)) {
            throw new Error("Expected the field `campaignTitle` to be a primitive type in the JSON string but got " + data['campaignTitle']);
        }
        // ensure the json data is a string
        if (data['campaignLogoImage'] && !(typeof data['campaignLogoImage'] === 'string' || data['campaignLogoImage'] instanceof String)) {
            throw new Error("Expected the field `campaignLogoImage` to be a primitive type in the JSON string but got " + data['campaignLogoImage']);
        }
        // ensure the json data is a string
        if (data['campaignDesc'] && !(typeof data['campaignDesc'] === 'string' || data['campaignDesc'] instanceof String)) {
            throw new Error("Expected the field `campaignDesc` to be a primitive type in the JSON string but got " + data['campaignDesc']);
        }
        // ensure the json data is a string
        if (data['region'] && !(typeof data['region'] === 'string' || data['region'] instanceof String)) {
            throw new Error("Expected the field `region` to be a primitive type in the JSON string but got " + data['region']);
        }
        // ensure the json data is a string
        if (data['partnerEmail'] && !(typeof data['partnerEmail'] === 'string' || data['partnerEmail'] instanceof String)) {
            throw new Error("Expected the field `partnerEmail` to be a primitive type in the JSON string but got " + data['partnerEmail']);
        }
        // ensure the json data is a string
        if (data['enableStartAt'] && !(typeof data['enableStartAt'] === 'string' || data['enableStartAt'] instanceof String)) {
            throw new Error("Expected the field `enableStartAt` to be a primitive type in the JSON string but got " + data['enableStartAt']);
        }
        // ensure the json data is a string
        if (data['enableEndAt'] && !(typeof data['enableEndAt'] === 'string' || data['enableEndAt'] instanceof String)) {
            throw new Error("Expected the field `enableEndAt` to be a primitive type in the JSON string but got " + data['enableEndAt']);
        }

        return true;
    }


}



/**
 * @member {String} walletAddress
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['walletAddress'] = undefined;

/**
 * @member {Number} depositAmount
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['depositAmount'] = undefined;

/**
 * @member {String} packageName
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['packageName'] = undefined;

/**
 * @member {String} appTitle
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['appTitle'] = undefined;

/**
 * @member {String} appProfileImage
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['appProfileImage'] = undefined;

/**
 * @member {Number} campaignType
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['campaignType'] = undefined;

/**
 * @member {String} campaignTitle
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['campaignTitle'] = undefined;

/**
 * @member {Date} startAt
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['startAt'] = undefined;

/**
 * @member {Date} endAt
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['endAt'] = undefined;

/**
 * @member {Number} appNo
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['appNo'] = undefined;

/**
 * @member {Boolean} isLock
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['isLock'] = undefined;

/**
 * @member {String} campaignLogoImage
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['campaignLogoImage'] = undefined;

/**
 * @member {String} campaignDesc
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['campaignDesc'] = undefined;

/**
 * @member {String} region
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['region'] = undefined;

/**
 * @member {Number} needMinNftGrade
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['needMinNftGrade'] = undefined;

/**
 * @member {Number} needMinNftLevel
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['needMinNftLevel'] = undefined;

/**
 * @member {Number} needNftType
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['needNftType'] = undefined;

/**
 * @member {Number} needType
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['needType'] = undefined;

/**
 * @member {Number} needValue
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['needValue'] = undefined;

/**
 * @member {Number} initialPerDeposited
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['initialPerDeposited'] = undefined;

/**
 * @member {Number} dailyPerLeftover
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['dailyPerLeftover'] = undefined;

/**
 * @member {Number} usePowerDayLimit
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['usePowerDayLimit'] = undefined;

/**
 * @member {Number} perOfBasicPower
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['perOfBasicPower'] = undefined;

/**
 * @member {Number} perBasicPower
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['perBasicPower'] = undefined;

/**
 * @member {Number} xperOfBasicPower
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['xperOfBasicPower'] = undefined;

/**
 * @member {Number} xperBasicPower
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['xperBasicPower'] = undefined;

/**
 * @member {Number} partnerNo
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['partnerNo'] = undefined;

/**
 * @member {String} partnerEmail
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['partnerEmail'] = undefined;

/**
 * @member {Date} createdAt
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['createdAt'] = undefined;

/**
 * @member {Date} updatedAt
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['updatedAt'] = undefined;

/**
 * @member {Number} depositTransactionStatus
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['depositTransactionStatus'] = undefined;

/**
 * @member {Number} partnerWalletNo
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['partnerWalletNo'] = undefined;

/**
 * @member {Boolean} x2eZone
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['x2eZone'] = undefined;

/**
 * @member {Boolean} isAdvertised
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['isAdvertised'] = undefined;

/**
 * @member {Boolean} isEqualNftGrade
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['isEqualNftGrade'] = undefined;

/**
 * @member {String} enableStartAt
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['enableStartAt'] = undefined;

/**
 * @member {String} enableEndAt
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['enableEndAt'] = undefined;

/**
 * @member {Boolean} plusFlag
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['plusFlag'] = undefined;

/**
 * @member {Number} ticketId
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['ticketId'] = undefined;

/**
 * @member {Number} ticketCount
 */
CampaignControllerDtoCampaignDetailCampaignDetailData.prototype['ticketCount'] = undefined;






export default CampaignControllerDtoCampaignDetailCampaignDetailData;

